module.exports = __webpack_public_path__ + "static/media/10.0e64d1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/10.png
// module id = 1507
// module chunks = 0